import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  outreachSimulationFilterData: []
}

const outreachSimulationFilterSlice = createSlice({
  name: 'outreachSimulationFilter',
  initialState,
  reducers: {
    setOutreachSimulationFilterData: (state, action) => {
      state.outreachSimulationFilterData = action.payload
    }
  }
})

export const {setOutreachSimulationFilterData} = outreachSimulationFilterSlice.actions

// Selectors with null-safe defaults
export const selectOutreachSimulationFilterData = (state) =>
  state.outreachSimulationFilter?.outreachSimulationFilterData ?? []

export default outreachSimulationFilterSlice.reducer
